import { create } from "zustand";
import { getDeals } from "../services/contact_service";

const useDealStore = create((set, get) => ({
  deals: [],
  hydrated: false,
  loading: false,
  error: "",

  hydrateDeals: async ({ force = false } = {}) => {
    if (get().loading || (!force && get().hydrated)) {
      return;
    }

    set({ loading: true, error: "" });

    try {
      const data = await getDeals();
      set({
        deals: Array.isArray(data) ? data : [],
        hydrated: true,
        loading: false,
        error: "",
      });
    } catch (err) {
      set({
        deals: [],
        hydrated: false,
        loading: false,
        error: err?.message || "Failed to hydrate deals",
      });
    }
  },

  refreshDeals: async () => {
    await get().hydrateDeals({ force: true });
  },

  setDeals: (deals = []) =>
    set({
      deals,
      hydrated: true,
      error: "",
    }),

  addDealOptimistic: (deal) =>
    set((state) => ({
      deals: [deal, ...state.deals],
      hydrated: true,
      error: "",
    })),

  replaceOptimisticDeal: (tempId, persistedDeal) =>
    set((state) => ({
      deals: state.deals.map((deal) =>
        Number(deal.id) === Number(tempId)
          ? { ...deal, ...persistedDeal }
          : deal
      ),
    })),

  removeDealFromStore: (dealId) =>
    set((state) => ({
      deals: state.deals.filter((deal) => Number(deal.id) !== Number(dealId)),
    })),

  updateDealStageInState: (dealId, update) =>
    set((state) => ({
      deals: state.deals.map((deal) =>
        Number(deal.id) === Number(dealId)
          ? { ...deal, ...(typeof update === "string" ? { stage: update } : update) }
          : deal
      ),
    })),

  updateDealInStore: (updatedDeal) =>
    set((state) => ({
      deals: state.deals.map((deal) =>
        Number(deal.id) === Number(updatedDeal.id)
          ? { ...deal, ...updatedDeal }
          : deal
      ),
    })),

  resetDeals: () =>
    set({
      deals: [],
      hydrated: false,
      loading: false,
      error: "",
    }),
}));

export default useDealStore;
